import { render } from "./SplashScreen.vue?vue&type=template&id=165b579e&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"

import "./SplashScreen.vue?vue&type=style&index=0&id=165b579e&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-165b579e"

export default script